function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingPlans4 = function SvgLandingPlans4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18202_16759)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "#FF84E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5821 19.5H34.6654C34.3432 19.5 34.0821 19.7612 34.0821 20.0833V20.1521L38.1654 23.4187V20.0833C38.1654 19.7612 37.9042 19.5 37.5821 19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5404 27.0833C28.5404 26.2779 29.1933 25.625 29.9987 25.625C30.8041 25.625 31.4571 26.2779 31.4571 27.0833C31.4571 27.8887 30.8041 28.5417 29.9987 28.5417C29.1933 28.5417 28.5404 27.8887 28.5404 27.0833Z",
    fill: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2071 28.7872L41.1188 29.5166C41.4961 29.8185 42.0468 29.7573 42.3487 29.3799C42.6505 29.0026 42.5894 28.452 42.212 28.1501L32.7318 20.5659C31.1339 19.2876 28.8635 19.2876 27.2657 20.5659L17.7855 28.1501C17.4081 28.452 17.3469 29.0026 17.6488 29.3799C17.9507 29.7573 18.5013 29.8185 18.8787 29.5166L19.7904 28.7872V40.7917H18.3321C17.8488 40.7917 17.4571 41.1834 17.4571 41.6667C17.4571 42.1499 17.8488 42.5417 18.3321 42.5417H41.6654C42.1486 42.5417 42.5404 42.1499 42.5404 41.6667C42.5404 41.1834 42.1486 40.7917 41.6654 40.7917H40.2071V28.7872ZM26.7904 27.0833C26.7904 25.3114 28.2268 23.875 29.9987 23.875C31.7706 23.875 33.2071 25.3114 33.2071 27.0833C33.2071 28.8552 31.7706 30.2917 29.9987 30.2917C28.2268 30.2917 26.7904 28.8552 26.7904 27.0833ZM30.0563 31.4583C30.832 31.4583 31.5003 31.4583 32.0355 31.5302C32.6091 31.6073 33.1589 31.7812 33.6049 32.2272C34.0508 32.6731 34.2247 33.2229 34.3019 33.7965C34.3693 34.2983 34.3735 34.917 34.3737 35.6315C34.3737 35.6792 34.3737 35.7273 34.3737 35.7757L34.3737 40.7917H32.6237V35.8333C32.6237 34.9836 32.6219 34.4344 32.5675 34.0297C32.5164 33.6502 32.4341 33.5312 32.3674 33.4646C32.3008 33.398 32.1819 33.3156 31.8024 33.2646C31.3977 33.2102 30.8484 33.2083 29.9987 33.2083C29.149 33.2083 28.5998 33.2102 28.1951 33.2646C27.8156 33.3156 27.6966 33.398 27.63 33.4646C27.5634 33.5312 27.481 33.6502 27.43 34.0297C27.3756 34.4344 27.3737 34.9836 27.3737 35.8333V40.7917H25.6237L25.6237 35.7757C25.6237 35.0001 25.6236 34.3317 25.6956 33.7965C25.7727 33.2229 25.9466 32.6731 26.3926 32.2272C26.8385 31.7812 27.3883 31.6073 27.9619 31.5302C28.4971 31.4583 29.1655 31.4583 29.9411 31.4583H30.0563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5404 27.0833C28.5404 26.2779 29.1933 25.625 29.9987 25.625C30.8041 25.625 31.4571 26.2779 31.4571 27.0833C31.4571 27.8887 30.8041 28.5417 29.9987 28.5417C29.1933 28.5417 28.5404 27.8887 28.5404 27.0833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_dii_18202_16759)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.289062,
    width: 62.7024,
    height: 62.0133,
    rx: 24,
    transform: "rotate(-0.27563 0 0.289062)",
    fill: "url(#paint0_linear_18202_16759)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_18202_16759",
    x: -4.42874,
    y: -3.7916,
    width: 78.9949,
    height: 76.3609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18202_16759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_18202_16759",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18202_16759"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.54202,
    dy: -3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_18202_16759",
    result: "effect3_innerShadow_18202_16759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18202_16759",
    x1: 10.8965,
    y1: 7.85166,
    x2: 52.6412,
    y2: 53.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18202_16759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "white"
  }))));
};
export default SvgLandingPlans4;